import React, { useContext, useEffect, useState } from "react";
import styles from "./PosterInitialSelected.module.css";
import { PopupWrapper } from "../../UI/PopupWrapper";
import closeIcon from "../../assests/posterCreation/closeWhiteRounded.svg";
import { useNavigate } from "react-router";
import nextIcon from "../../assests/posterCreation/nextIcon.svg";
import previousIcon from "../../assests/posterCreation/previousIcon.svg";
import Context from "../../context/Context";
import { useUserAuth } from "../../context/UserAuthContext";

function PosterInitialSelected({
  visible,
  close,
  ocassionData,
  popupImageIndex,
}) {
  const navigate = useNavigate();
  const [currentIndex, setCurrentIndex] = useState(popupImageIndex);
  const [popupImage, setPopImage] = useState("");
  const { setSelectedBackground } = useContext(Context);
  const { setPreviousLocation } = useUserAuth();
  const mode = window.location.pathname.split("/")[1]?.replace(/\.html$/, "");

  useEffect(() => {
    setPopImage(ocassionData?.backgrounds[currentIndex]?.sampleUrl);
  }, [currentIndex]);

  const nextItem = () => {
    setCurrentIndex((prev) =>
      prev === ocassionData?.backgrounds?.length - 1 ? 0 : prev + 1
    );
  };

  const prevItem = () => {
    setCurrentIndex((prev) =>
      prev === 0 ? ocassionData?.backgrounds?.length - 1 : prev - 1
    );
  };

  const isPrevDisabled = currentIndex === 0;
  const isNextDisabled = currentIndex === ocassionData?.backgrounds?.length - 1;

  return (
    <PopupWrapper visible={visible} close={close}>
      <div className={styles.posterSelectedContainer}>
        <div className="className= flex w-full justify-end px-[20px] mb-[24px]">
          <img onClick={() => close(false)} src={closeIcon} alt="" />
        </div>
        <div className="flex  justify-center items-center  relative w-full max-w-[425px] mb-[24px] ">
          {/* <img className={styles.previousImage} src={previousImage} alt="" /> */}
          <img className={styles.currentImage} src={popupImage} alt="" />
          {/* <img className={styles.upcomingImage} src={upcomingImage} alt="" /> */}
          {!isPrevDisabled ? (
            <img
              className={styles.next}
              onClick={prevItem}
              src={previousIcon}
              alt=""
            />
          ) : (
            <img
              className={styles.nextDisabled}
              // onClick={prevItem}
              src={previousIcon}
              alt=""
            />
          )}
          {!isNextDisabled ? (
            <img
              className={styles.previous}
              onClick={nextItem}
              src={nextIcon}
              alt=""
            />
          ) : (
            <img
              className={styles.previousDisabled}
              // onClick={nextItem}
              src={nextIcon}
              alt=""
            />
          )}
        </div>
        <div className="mb-[60px]">
          <button
            onClick={() => {
              setSelectedBackground(ocassionData?.backgrounds[currentIndex]);
              setPreviousLocation(window.location.pathname);
              navigate("upload");
              close(false);
            }}
            className="  rounded-[74px] bg-white px-[56px] py-[15px] text-black text-[16px] font-medium leading-[21px] "
          >
            {mode == "faceswap" ? "Use this Image" : "Use this background"}
          </button>
        </div>
        {ocassionData?.backgrounds[currentIndex]?.reference && (
          <p className=" w-full px-[20px] mb-[20px] text-left">
            Reference Images - Before & After
          </p>
        )}{" "}
        <div className="flex flex-col gap-[16px] pb-[24px] px-[20px] ">
          {ocassionData?.backgrounds[currentIndex]?.reference?.map(
            (obj, index) => {
              return (
                <div key={index} className="">
                  <img src={obj} alt="" className="rounded-[12px]" />
                </div>
              );
            }
          )}
        </div>
      </div>
    </PopupWrapper>
  );
}

export default PosterInitialSelected;
